import {
  BaseQueryFn,
  FetchArgs,
  FetchBaseQueryError,
  fetchBaseQuery,
} from '@reduxjs/toolkit/dist/query';
import { Mutex } from 'async-mutex';
import { RootState, logout, selectUser, setAuth } from 'core';
import queryString from 'query-string';
import { AuthContext } from 'types';

const mutex = new Mutex();

const baseQuery = fetchBaseQuery({
  prepareHeaders: (headers, api) => {
    const auth = selectUser(api.getState() as RootState);

    if (auth?.jwt) {
      headers.set('Authorization', `Bearer ${auth.jwt}`);
    }
  },
  paramsSerializer: queryString.stringify,
});

export const OdinBaseQuery: BaseQueryFn<
  string | FetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, opts) => {
  await mutex.waitForUnlock();

  const initialResult = await baseQuery(args, api, opts);
  if (initialResult?.error?.status !== 401) return initialResult;

  if (!mutex.isLocked()) {
    const release = await mutex.acquire();
    try {
      const auth = selectUser(api.getState() as RootState);
      const refreshToken = auth?.refreshToken;
      const sub = auth?.user?.subscriptionId;
      if (!(refreshToken && sub)) {
        api.dispatch(logout({}));
        return initialResult;
      }

      const renewalResponse = await baseQuery(
        {
          url: '/api/refresh-token',
          method: 'POST',
          body: {
            sub,
            refreshToken,
          },
        },
        api,
        opts
      );
      if (renewalResponse.error) {
        await api.dispatch(logout({}));
        return renewalResponse;
      }

      const partialData = renewalResponse.data as Pick<
        AuthContext,
        'jwt' | 'expiresIn'
      >;
      const outcome = {
        ...auth,
        ...partialData,
      };
      await api.dispatch(setAuth(outcome));
      return await baseQuery(args, api, opts);
    } finally {
      release();
    }
  } else {
    await mutex.waitForUnlock();
    return await baseQuery(args, api, opts);
  }
};

export const HourSeconds = 216000;

// import { fetchBaseQuery } from '@reduxjs/toolkit/query'
// import type {
//   BaseQueryFn,
//   FetchArgs,
//   FetchBaseQueryError,
// } from '@reduxjs/toolkit/query'
// import { tokenReceived, loggedOut } from './authSlice'

// const baseQuery = fetchBaseQuery({ baseUrl: '/' })
// const baseQueryWithReauth: BaseQueryFn<
//   string | FetchArgs,
//   unknown,
//   FetchBaseQueryError
// > = async (args, api, extraOptions) => {
//   let result = await baseQuery(args, api, extraOptions)
//   if (result.error && result.error.status === 401) {
//     // try to get a new token
//     const refreshResult = await baseQuery('/refreshToken', api, extraOptions)
//     if (refreshResult.data) {
//       // store the new token
//       api.dispatch(tokenReceived(refreshResult.data))
//       // retry the initial query
//       result = await baseQuery(args, api, extraOptions)
//     } else {
//       api.dispatch(loggedOut())
//     }
//   }
//   return result
// }
